<template>
  <div class="m-orderTotal">
    <div class="container heading">
      <span class="m-orderTotal__amount">
        <i class="fa fas fa-shopping-cart" aria-hidden="true"></i>
        <span>{{ totalCurrency }} {{ totalAmount }}</span>
      </span>
      <span class="m-orderTotal__mobileSpinner" v-show="taxChangeLoading">
        <i class="fad fa-spinner-third fa-spin" aria-hidden="true"></i>
      </span>
      <router-link class="a-Link--Blue nav-link m-orderTotal__btn" to="/cart">View order</router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState({
    totalCurrency: state => state.cart.currency,
    totalAmount: state => state.cart.totalAmount,
    taxChangeLoading: state => state.globalstate.taxChangeLoading
  }),

  watch: {
    taxChangeLoading () {
      const orderAmount = document.getElementsByClassName('m-orderTotal__amount')[0]
      if (orderAmount !== undefined) {
        if (this.taxChangeLoading === true) {
          orderAmount.style.opacity = 0.2
        } else {
          orderAmount.style.opacity = 1
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// MobileNavTotalOrder.vue?1bc1da56